<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="工单详情" size="75%" :before-close="handleClose" :visible.sync="drawer"
      direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <checkBillView visible-key="showEdit" :_dataId.sync="dataId" ></checkBillView>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import checkBillView from "@/views/workorder/supervise/list/edit.vue";
import api from "@/api/projectApi";
export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'row1'],
  components: {
    checkBillView
  },
  created() {
    this.dataId = this.row1
    console.log(this.dataId, "传过来的值");
  },
  data() {
    return {
      show3: false,
      dataId: '',
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,

      drawer: true,
      formData: {
        orderNo: '', // 工单号,前缀"SO"+年月日+6位流水号
        createType: 0, // 生成方式：0默认;1客服;2excel;3接口;4公众号;5PC自建单;6APP自建单;7服务中心;9其它;94苏宁帮客;95京东服务市场;97天猫服务市场;98京东测量服务;99京东ue平台;100京东3C
        orderTypeId: 0, // 工单来源ID,关联bas_order_type.id
        serverTypeId: 0, // 服务类型ID,关联bas_service_type.id
        userType: 0, // 用户类型:0普通用户、1售前机、2工程机、3VIP用户、4经销商
        userName: '', // 用户姓名
        userMobile: '', // 来电号码
        userPhone1: '', // 其他号码1
        userPhone2: '', // 其他号码2
        userProvice: '', // 省
        userCity: '', // 市
        userCounty: '', // 县
        userTown: '', // 镇街
        areaId: 0, // 地区ID,关联bas_area.id
        userAddress: '', // 详细地址
        longitude: 0, // 经度
        latitude: 0, // 纬度
        guaranteeType: 0, // 保修类型：1保内、2保外、3未知
        brandId: 0, // 品牌ID,关联sn_company_brand.id
        buyDate: '', // 购买时间
        buyShop: '', // 购买商场
        invoiceNo: '', // 发票号
        brarcode: '', // 报单条码
        outOrderNo: '', // 外部订单号
        complaintTypeId: 0, // 客诉类型ID,关联bas_customer_complaint_type.id
        issueFaultId: 0, // 客服录单故障现象id,关联bas_fault_symptom.id
        appeals: '', // 述求
        stat: 0, // 状态：1登记;2发布;5已派网点;9已派师傅;13已出发;17已上门;20完工暂存;21已完工;22网点确认完工;23中心确认完工;24总部确认完工;91待结算;92结算驳回;93结算中止;94已结算;98挂起;99取消
        dispatchStat: '', // 工单标签
        partsStat: 0, // 配件状态：0无配件;1申请；2审核；3出库；4网点收货；8驳回；9取消；11更换；12网点返厂；13返厂确认
        recallStat: 0, // 回访状态：0未回访、1已抽样、2已回访;5用户已评价
        siteComplainStat: 0, // 申诉状态：0无申诉；3待申诉；5已申诉；7中心已审核；8中心驳回；9总部已处理；99取消
        qualityStat: 0, // 质检状态：0未质检；1质检通过；2质检不通过；
        orgId: 0, // 业务机构，关联脚手架机构表sys_dept.dept_id
        orgName: '', // 机构名称,冗余字段
        orgIdPath: '', // 机构ID路径,冗余字段.重要
        siteId: 0, // 网点ID,关联sn_user.id;
        siteName: '', // 网点名称,冗余字段
        bigSiteId: null,
        bigSiteName: '',
        engineerId: 0, // 工程师Id,关联sn_site_engineer.id
        engineerName: '', // 工程师名称,冗余字段
        takeTime: null, // 派单时间
        takeEngineerTime: null, // 派工程师时间
        openId: '', // 消费者报修时关联的微信号id
        sysmtomId: 0, // 故障现象id,关联bas_fault_symptom.id
        reasonId: 0, // 故障原因id,关联bas_fault_reason.id
        methodId: 0, // 维修措施id,关联bas_fix_method.id
        isMustRecall: 0, // 是否必访:0否1是
        isCallRecall: 0, // 是否可抽样:0否1是
        isUrgent: 0, // 是否急单:0否1是
        isReplaceFinish: 0, // 是否重新完工：0否1是
        urgeTimes: 0, // 催单次数
        complainTimes: 0, // 投诉次数
        managerId: 0, // 督办人,关联sys_user.id
        outTransIn: 0, // 申请保外转保内:0否1是
        settleId: 0, // 结算单ID,关联sf_batch_settle.id字段
        sendPay: '', // sendPay:打标标识，未定义
        serverTypeName: null,
        orderTypeName: null,
        symptomName: null,
        reasonName: null,
        methodName: null,
        createrNumber: null, // 创建人工号;对应sys_user.username
        addressNumber: null,
        urger: null,

        soOrderExtendDTO: {
          wishBookDate: '', // 期望上门/安装时间
          deliverTime: '', // 到货签收时间
          finishMode: 0, // 完工模式：1结算密码；2上传图片；3图片+条码；9无验证完工
          finishType: 0, // 完工方式:1总部代完工;2网点PC端完工;3网点APP完工;4师傅APP完工;5接口完工;9其他
          commentLevel: 0, // 短信满意度：1非常满意;2满意;3一般;4不满意;5非常不满意
          isSendCommentMessage: 0, // 是否已发送评价短信：0否1是
          qualityMan: '', // 质检人
          qualityDate: '', // 质检时间
          qualityRemark: '', // 质检备注
          secondSiteComplain: 0, // 是否二次申诉：0否1是
          isInstallSynchro: 0, // 是否送装同步：0否1是
          hangupType: 0, // 挂起类型：0总部挂起；1网点挂起
          hangupReason: '', // 挂起原因
          sendFlag: 0, // 外部系统传单标识:0未传;1失败;2已传
          sendMessage: '', // 外部系统传单返回信息
          sendDate: '', // 外部系统传单时间
          thirdSendFlag: 0, // 传第三方网点接口状态:0未传;1失败;2已传
          thirdSendDate: '', // 传第三方网点接口时间
          thirdSendMessage: '', // 传第三方网点接口备注,如失败时用来保存失败的原因
          tmfworderid: '', // 天猫服务市场的工单ID
          tbcustomerid: '', // 天猫服务市场的用户ID
          commercePraise: 0, // 是否电商好评：0否1是

          complaintObjectName: '', // 投诉对象
          complaintProperty: null, // 投诉性质ID,关联脚手架数据字典项目表sys_dict_item.id
          dealSatisfaction: 0,
          dutyJudge: null, // 责任判定ID,关联脚手架数据字典项目表sys_dict_item.id
          dutyJudgeSub: null, // 责任细分ID,关联脚手架数据字典项目表sys_dict_item.id
          handleModel: null, // 处理方式ID,关联脚手架数据字典项目表sys_dict_item.id
          handlePlan: '', // 处理方案
          consultType: null, // 咨询类型ID,关联脚手架数据字典项目表sys_dict_item.id
          consultTypeSub: null, //  咨询细分ID,关联脚手架数据字典项目表sys_dict_item.id
          praiseObjectName: '', //  表扬对象
          praiseType: null, //  表扬类型ID,关联脚手架数据字典项目表sys_dict_item.id
          praiseJudge: 0, //   表扬是否成立:0否1是
          rewardJudge: 0, //  奖励是否成立:0否1是

          complaintPropertyName: null,
          isIntransfer: null,
          dealSatisfactionName: null,
          dutyJudgeName: null,
          dutyJudgeSubName: null,
          handleModelName: null,
          consultTypeName: null,
          consultTypeSubName: null,
          praiseTypeName: null,

        },
        soOrderProcessDTO: {
          orderId: 0, // 工单id，关联so_order.id
          takeOrgTime: '', // 派中心时间
          // takeTime: '', // 派单时间
          acceptOperateTime: '', // 网点确认接单时间
          // takeEngineerTime: '', // 派工程师时间
          engineerAcceptOperateTime: '', // 工程师确认接单时间
          firstBookOperateTime: '', // 首次预约操作时间
          firstBookDate: '', // 首次预约时间
          bookOperateTime: '', // 预约操作时间
          bookDate: '', // 预约时间
          startOffTime: '', // 出发时间
          onDoorTime: '', // 上门签到时间
          onDoorLocation: '', // 上门签到地址
          firstCompleteTime: '', // 首次完工时间
          completeTime: '', // 完工时间
          onTimeLocation: '', // 完工地址
          siteComfirmTime: '', // 网点确认完工时间
          orgComfirmTime: '', // 中心确认完工时间
          officeComfirmTime: '', // 总部确认完工时间
          recallTime: '', // 回访时间
          complaintProcessTimes: 0, // 客诉跟进次数
          complaintProcesser: '', // 客诉跟进人
          complaintProcessDate: '', // 客诉跟进时间
          siteComplaintProcessDate: '', // 网点客诉跟进时间
          applyPayDate: '', // 进入结算池时间
          payDate: '', // 提交结算时间
          cancleDate: '', // 取消/退单时间
          returnId: 0, // 取消/退单原因：关联bas_return_type.id.
          returnName: null, // 取消/退单原因：关联bas_return_type.id.
          finishNote: '', // 完工备注
          comfirmNote: '', // 完工审核备注
          fixStatus: 0,//维修状态
          bookTimes: 0,//预约次数
        },
        soOrderCommentDTO: {
          speed: 0,  // 响应速度评分
          effect: 0,  // 服务效果评分
          fee: 0,  // 合理收费评分
          other: null,  // 其他评价
          pic1: null,  // 图片1
          pic2: null,  // 图片2
          pic3: null,  // 图片3
          topLevel: 0,  // 总体评价:1非常满意;2满意;3一般;4不满意;5非常不满意
          unSatisfiedReasonName: null,  // 不满意原因
          unSatisfiedReasonRemark: null,  // 不满意描述
          question1: null,  // 问题1描述
          question1Answer: 0,  // 问题1答案:0否1是
          question2: null,  // 问题2描述
          question2Answer: 0,  // 问题2答案:0否1是
          question3: null,  // 问题3描述
          question3Answer: 0,  // 问题4答案:0否1是
          question4: null,  // 问题4描述
          question4Answer: 0,  // 问题4答案:0否1是
          sources: 0,  // 评价来源:1电商接口;2短信回复评价;3用户微信评价;4APP扫码评价
        },
        soOrderSettleDTO: {
          siteFinalAmount: null,
          siteAmount: null,
          rewardAmount: null,
          mapLongDistance: null,
          longDistance: null,
          longDistanceAmount: null,
          userPayType: null,
          userPayName: null,
          userPayAccount: null,
          userPayStat: null,
          userPayNo: null,
          userPayTime: null,
          userPayStatMsg: null,
          productDate: null,
          installDate: null
        },
        soOrderResultDTO: {
          inCode: null,
          outCode: null,
          finishPic1: null,
          finishPic2: null,
          finishPic3: null,
          finishPic4: null,
          finishPic5: null,
          finishPic6: null,
        },
        soOrderComplainDTOList: [],
        soOrderLineDTOList: [{}],
        soOrderPartsDTOList: [],
        soOrderPreconditionResultDTOList: [],
        soOrderOperationDTOList: [],
        soOrderSlaList: [],
        sfCheckBillDTOList: [],
        soOrderFaultDTOList: [],
        soOrderFeeAttributeList: []
      },
      srcList: [],

    }
  },
  mounted() {
    // this.initTableList();
    this.getData();
    //   console.log(this.tenant, "tenant的值");
    console.log(this.dataId, "_dataId的值");
  },
  methods: {
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        //   this.isEdit = true;
        this.$http({
          url: api.soOrder.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          console.log(this.formData, "this.formData请求的值");
          this.srcList.push(this.formData.soOrderResultDTO.finishPic1)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic2)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic3)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic4)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic5)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic6)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic7)
          if (this.formData.soOrderComplainDTOList != null && this.formData.soOrderComplainDTOList.length != 0) {
            this.formData.soOrderComplainDTOList.forEach(item => {
              let list = []
              if (item.fileUrl1 != null) {
                list.push(item.fileUrl1)
              }
              if (item.fileUrl2 != null) {
                list.push(item.fileUrl)
              }
              if (item.fileUrl3 != null) {
                list.push(item.fileUrl3)
              }
              item.srcList = list
            })
          }
        })
      } else {
        this.enabled = true;
      }
    },
    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.orderNo = row.orderNo
      this.formData.orderId = row.orderId
    },
    shut() {
      // this.showOrderPop=true
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0, );
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    // right: 20%;
    left: 13vw;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}

.Instructions {
  text-decoration: underline;
  color: #00c4b3;
  margin-left: 5px;
}
</style>
